export const EMPLOYMENT_STATUS = {
    Tetap: {
        label: 'Tetap',
        className: 'bg-green-100 text-green-800'
    },
    Kontrak: {
        label: 'Kontrak',
        className: 'bg-blue-100 text-blue-800'
    },
    Magang: {
        label: 'Magang',
        className: 'bg-purple-100 text-purple-800'
    }
} as const;

type Props = {
    status: keyof typeof EMPLOYMENT_STATUS | string;
};

export default function EmployeeStatusBadge({ status }: Props) {
    const data = EMPLOYMENT_STATUS[status as keyof typeof EMPLOYMENT_STATUS];

    if (!data) {
        return (
            <span className="px-3 py-1 text-xs font-semibold bg-gray-100 text-gray-800 rounded-full">
                Tidak Diketahui
            </span>
        );
    }

    return (
        <span className={`px-3 py-1 text-xs font-semibold rounded-full ${data.className}`}>
            {data.label}
        </span>
    );
}